import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "RecentNotReply" }
const _hoisted_2 = { style: {"align-items":"center","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"margin-left":"10px"} }

import { searchFormConfig } from '@/views/main/wechatMgmt/recentNotReply/config/search.config'
import { contentTableConfig } from '@/views/main/wechatMgmt/recentNotReply/config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { createData, getListData } from '@/service/main/system'
import { useStore } from '@/store'
import { initEmptyParam } from '@/hooks/useInitParam'
import { modalConfig } from './config/modal.config'
import { ref } from 'vue'
import PageModal from '@/components/PageModal.vue'
import { ElMessage } from 'element-plus/es'


export default /*#__PURE__*/_defineComponent({
  __name: 'RecentNotReply',
  setup(__props) {

initEmptyParam()
const store = useStore()
const getCompanyList = async () => {
  let corpData = await getListData('/main/enterpriseWechat/config/listAll', {})
  const corpItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpId'
  )

  const mCorpItem = modalConfig.formItems.find(
    (item) => item.field === 'corpId'
  )

  corpItem!.options = corpData.map((item: any) => {
    return { title: item.name, value: item.id }
  })

  mCorpItem!.options = corpData.map((item: any) => {
    return { title: item.name, value: item.corPid }
  })
}
getCompanyList()

const getUsedBy = async () => {
  let userList = await getListData(
    '/main/enterpriseWechat/dingUser/listAll',
    {}
  )
  const userOptions = userList.map((item: any) => {
    return { title: item.userName, value: item.userName }
  })
  const usedByItem = searchFormConfig.formItems.find(
    (item) => item.field === 'usedBy'
  )
  usedByItem!.options = userOptions
}
getUsedBy()

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

let queryParam = ref()
if (store.state.login.userInfo.isManager != '1') {
  queryParam.value = {
    usedBy: store.state.login.userInfo.realName,
    removeD: '1'
  }
} else {
  queryParam.value = {
    removeD: '1'
  }
}
store.commit('system/changeQueyryInfo', queryParam.value)
const resetCb = () => {
  return queryParam.value
}

const handleUpdateBatchData = async (formData: any) => {
  try {
    await createData('/main/transferCustomer/addTransferEvent', {
      ...formData
    })
    store.dispatch('system/getPageListAction', {
      pageName: 'recentNotReply',
      queryInfo: store.state.system.queryInfo
    })
    pageModalRef.value.dialogVisible = false
  } finally {
    pageModalRef.value.confirmLoading = false
    ElMessage({
      message: '转移申请已提交',
      type: 'success'
    })
  }
  store.commit('system/changeQueyryInfo', queryParam.value)
}

let notReplyIds: Array<number> = []
let customerIds: string
let customerName: string
let corpIds: Array<string> = []
let corpName: Array<string> = []
let userIds: Array<string> = []
// 多选框选择事件
const handleSlectionChange = (value: any[]) => {
  console.log(value)
  notReplyIds = []
  customerIds = ''
  customerName = ''
  corpIds = []
  corpName = []
  userIds = []
  for (const row of value) {
    notReplyIds.push(row.id)
    corpIds.push(row.corpId)
    corpName.push(row.corpName)
    userIds.push(row.sid)
    customerIds += row.uid + ', '
    customerName += row.uname + ', '
  }
  customerIds = customerIds.substring(0, customerIds.length - 2)
  customerName = customerName.substring(0, customerName.length - 2)
}

const defaultInfo = ref({})
const pageModalRef = ref<InstanceType<typeof PageModal>>()
const modalTitle = ref('批量转移')
const handleBatchEditCustomerBtnClick = () => {
  console.log('点击')
  if (notReplyIds.length == 0) {
    ElMessage({
      message: '请勾选转移客户',
      type: 'warning'
    })
    return
  }

  if (!areAllIdsTheSame(corpIds)) {
    ElMessage({
      message: '请选择同一个主体下的客户',
      type: 'warning'
    })
    return
  }

  if (!areAllIdsTheSame(userIds)) {
    ElMessage({
      message: '请选择同一个账号下的客户',
      type: 'warning'
    })
    return
  }

  defaultInfo.value = {
    externalUserid: customerIds,
    externalUsername: customerName,
    corpId: corpIds[0],
    corpName: corpName[0],
    handoverUserid: userIds[0]
  }
  modalTitle.value = '批量转移'
  pageModalRef.value.dialogVisible = true
  pageModalRef.value.isBatch = true
}

function areAllIdsTheSame(ids: Array<string>): boolean {
  if (ids.length <= 1) {
    return true
  }
  const firstId = ids[0]
  return ids.every((item) => item === firstId)
}

const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick,
  handleSummaryBtnClick
] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "recentNotReply",
      downFilename: "近期未回复客户详情.xlsx",
      summaryFilename: "待转移资源数汇总.xlsx",
      onBatchEditCustomerBtnClick: handleBatchEditCustomerBtnClick,
      onSelectionChange: handleSlectionChange,
      onDownBtnClick: _unref(handleDownBtnClick),
      onSummaryBtnClick: _unref(handleSummaryBtnClick),
      onSortChange: handleSortChange
    }, {
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 30,
            src: scope.row.avatar
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.uname) + " (" + _toDisplayString(scope.row.remark) + ") ", 1)
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick", "onSummaryBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: defaultInfo.value,
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "recentNotReply",
      onUpdateBatchData: handleUpdateBatchData
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})